export default {
    dashboard: {
        totalWordsGenerated: 'Samlet genererede ord',
        wordsPerDay: 'Ord/dag',
        content: 'Indhold',
        date: 'Dato',
        variationCount: 'Antal variationer',
        transactionId: 'Transaktions ID',
        totalWordsCount: 'Samlet antal ord',
        action: 'Handling',
        goTo: 'Gå til',
        viewMore: 'Se mere',
        showLess: 'Vis mindre',
        tabImage: 'billede',
        tabText: 'Tekst',
        dashboardSubtitle: 'Administrér dit AI-genererede indhold',
        type: 'Type',
    },
};
